<template>
  <div
    class="select-single bg-transparent inline-block pos-rel minw7 w100p"
    v-click-outside.self="closeMenu"
    :class="`${disabled ? 'disabled disabled-select ' : '' } ${isPlaceholderPresent ? 'no-float-label' : ''} ${classes}`"
    >
    <float-label :label="label" ref="floatLabel" :on="!isPlaceholderPresent">
      <div class="select">
        <div @click="toggleMenu" class="h3 dropdown-toggle w100p lh1-2 display-flex justify-center align-center ph1">
          {{ dataValue || selectedOption.label || placeholder || label }}
          <bh-icon v-if="showIcon" icon="play-down" @output="toggleMenu" class="pl1 text-violet inline f-5" />
        </div>
        <ul class="dropdown-menu w100p maxh40 overflow-auto scroll pos-abs top0 left0 bg-white pa0 ma0 br1" v-if="showMenu">
          <li class="display-flex align-center w100p border-bottom pointer text-left justify-center pa1 align-center" v-on="enableSearch ? {} : { click: emitValue.bind(this, '') }">
           <bh-search-bar
              v-if="enableSearch"
              :placeholder="searchPlaceholder"
              :autocomplete="autocomplete"
              :showIcon="false"
              searchInputClass="f1-5"
              @search="onSearch"
            />
            <!-- <span v-else> {{ placeholder || label }} </span> -->
          </li>
          <li class="list-item pa1 w100p border-bottom pointer text-left justify-around align-center"
            v-for="option in getOptions" :key="`key-${option.value}`"
            :id="optionId(option.value)"
            :class="{ 'selected' : option.value === value }"
            @click="emitValue(option.value)"
            >
            {{ option.label }}
          </li>
        </ul>
      </div>
      <!-- the actual select element is hidden -->
      <label :for="value" class="hidden-element none">
        <select class="bg-white pointer pos-rel none" :disabled="disabled" :required="required" :value="value" :id="value"></select>
      </label>
    </float-label>
  </div>
</template>

<script>
import FloatLabel from 'vue-float-label/components/FloatLabel'

export default {
  name: 'bh-select',
  components: {
    FloatLabel
  },
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    placeholder: {
      type: String,
      default: ''
    },
    searchPlaceholder: {
      type: String,
      default: 'Search Devices'
    },
    classes: {
      type: String,
      default: 'z-index'
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    value: {
      type: String | Number,
      default: ''
    },
    autocomplete: {
      type: String,
      default: ''
    },
    enableSearch: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => {
        return [
          { label: 'Default Options 1', value: '1' }
        ]
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      searchTerm: '',
      showMenu: false,
      svgSize: '3.375rem',
      dataValue: ''
    }
  },
  computed: {
    isPlaceholderPresent() {
      return Boolean(this.placeholder)
    },
    getOptions() {
      if (!this.searchTerm) {
        return this.options
      }
      return this.options.filter(option => {
        return option.label?.toLowerCase().includes(this.searchTerm.toLowerCase())
      })
    },
    selectedOption: {
      get() {
        return this.getOptions.filter(option => {
          if (option.value === this.value) {
            this.setFloatLabel(this.value)
            return option
          }
        })[0] || {}
      }
    }
  },
  watch: {
    value: {
      handler(value) {
        this.setFloatLabel(value)
      }
    }
  },
  methods: {
    optionId(value) {
      return value
        ? `option-${value.toString()}`
        : ''
    },

    setFloatLabel(value) {
      if (this.$refs['floatLabel']) {
        this.$refs['floatLabel'].isActive = this.isPlaceholderPresent ? false : !!value
      }
    },

    onSearch(searchTerm) {
      this.searchTerm = searchTerm
    },

    closeMenu() {
      this.showMenu = false
    },
    toggleMenu(e) {
      this.showMenu = !this.showMenu
    },

    emitValue(value) {
      this.dataValue = this.options[value].label
      this.showMenu = false
      this.$emit('output', value)
    }
  }
}
</script>

<style scoped>
  .select-single.disabled-select {
    opacity: 0.5;
  }

  .select {
    transition: all 0.4s ease;
  }

  .select-single.disabled-select .select {
    pointer-events: none;
  }

  ul.dropdown-menu {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  }

  .selected {
    background-color: #5764B3;
    color: #ffffff;
  }

  .list-item:hover {
    background-color: #5764B3;
    color: #ffffff;
  }
</style>
